import React from 'react';
import { DataProccessTable } from './DataProccessTable';
import { useRouter } from 'next/router';
import { tabs } from '../..';
import Link from 'next/link';
import { TextSmall } from '@/components/Texts';

const dataList = [
  '- the page from which the page was requested (so-called referrer URL).',
  '- the name and URL of the requested page',
  '- the date and time of the call',
  '- the description of the type, language and version of the web browser used.',
  '- The	 IP address of the requesting computer, which is shortened in such a way that a personal reference can no longer be established.',
  '- the amount of data transferred',
  '- the operating system',
  '- the message whether the call was successful (access status/http status code).',
  '- the GMT time zone difference',
];

const contactFrom = [
  '- surname and first name',
  '- address',
  '- company',
  '- e-mail address',
  '- time of transmission',
  '- correspondence',
];

const newsletterData = [
  '- the page from which the page was requested (so-called referrer URL).',
  '- the description of the type of the used web browser',
  '- the IP address of the requesting computer, which is shortened in such a way that a personal reference can no longer be established.',
  '- the e-mail address',
  '- the date and time of registration and confirmation',
];

const googleServer = [
  '- Language settings',
  '- IP address',
  '- Browser version, screen resolution of the browser and name of the browser',
];

const PersonalDataProcessed = () => {
  const router = useRouter();

  return (
    <>
      <TextSmall fontWeight={700}>(2) Personal data processed</TextSmall>
      <TextSmall>
        During the informative use of the websites, the following categories of
        personal data are collected, stored and processed by us:
      </TextSmall>
      <TextSmall>
        <TextSmall as='span' fontWeight={700}>
          &quot;Log data&quot;
        </TextSmall>
        : When you visit our websites, a so-called log data record (so-called
        server log files) is stored temporarily and anonymously on our web
        server. This consists of:
      </TextSmall>
      {dataList.map((data, index) => (
        <TextSmall key={index + 'data'} pl={4}>
          {data}
        </TextSmall>
      ))}
      <TextSmall>
        The collection is pseudonymized and is used to generate anonymous
        information about the way the site is used and to better tailor the
        content offered to users.
      </TextSmall>
      <TextSmall>
        Different services are used for each individual method and there is an
        individual right of objection:
      </TextSmall>

      <TextSmall>
        <TextSmall as='span' fontWeight={700}>
          &quot;Contact form data&quot;
        </TextSmall>
        : When contact forms are used, the data transmitted through them are
        processed. This consists of:
      </TextSmall>
      {contactFrom.map((data, index) => (
        <TextSmall key={index + 'contact'} pl={4}>
          {data}
        </TextSmall>
      ))}
      <TextSmall>
        The requests are deleted if they are no longer required. We review the
        necessity every six months; the statutory archiving obligations also
        apply.
      </TextSmall>
      <TextSmall>
        {`In addition, we offer the subscription to our newsletter, with which we
        inform you about current developments. If you subscribe to our
        newsletter, the following "newsletter data" will be collected, stored
        and processed by us:`}
      </TextSmall>
      {newsletterData.map((data, index) => (
        <TextSmall key={index + 'contact'} pl={4}>
          {data}
        </TextSmall>
      ))}
      <TextSmall>
        You can unsubscribe from the newsletter at any time. Contact form and
        e-mail communication data is processed for the purpose of handling
        customer inquiries (legal basis is Art. 6 para. 1 p. 1 lit. b or lit. f
        GDPR).
      </TextSmall>

      <TextSmall>
        <TextSmall as='span' fontWeight={700}>
          &quot;Google Analytics&quot;
        </TextSmall>
        {`: The website uses Google Analytics, a web analytics service provided by
        Google Inc, 1600 Amphitheatre Parkway, Mountain View, CA 94043, United
        States ("Google"). Google analyzes the use of this website on our
        behalf. Among other things, we use cookies for this purpose. The data
        processing is based on Art. 6 para. 1 lit. a GDPR (consent). The
        information collected by Google about the use of this website (the
        referring URL, pages visited on our website, web browser used, language
        setting, operating system used or screen resolution) is transferred to a
        Google server in the USA, stored there, analyzed and the result made
        available to us in anonymized form. Your usage data is not linked to
        your full IP address. We have activated the IP anonymization function
        offered by Google on this website so that the last octet (type IPv4) or
        the last 80 bits (type IPv6) of your IP address are deleted. Google is
        also certified in the EU-US Privacy Shield, so that an appropriate level
        of data protection is established for data at Google in the USA. You can
        revoke your consent to web analysis at any time:`}
      </TextSmall>
      <TextSmall pl={4}>
        - You may refuse the use of cookies by selecting the appropriate
        settings on your browser, you can close the cookie any time{' '}
        <TextSmall
          cursor={'pointer'}
          as={'span'}
          color={'blue'}
          _hover={{ cursor: 'pointer' }}
          onClick={() => {
            router.push(`?tab=${tabs['cookies-policy'].value}`, undefined, {
              shallow: true,
              scroll: true,
            });
          }}
        >
          here
        </TextSmall>{' '}
        however please note that if you do this you may not be able to use the
        full functionality of this website.
      </TextSmall>
      <TextSmall pl={4}>
        - You can also prevent the collection of data generated by the cookie
        and related to your use of our website (including your IP address) by
        Google, as well as the processing of this data by Google, by downloading
        and installing the browser plugin available at the following link
        (https://tools.google.com/dlpage/gaoptout?hl=de).
      </TextSmall>
      <TextSmall>
        Both options prevent web analysis only as long as you use a browser on
        which you have installed the plugin or as long as you do not delete the
        opt-out cookie. Further information on Google Analytics can be found in
        the Google Analytics Terms of Use, in the Google Analytics Security and
        Privacy Policy and in the Google Privacy Policy,{' '}
        <Link
          href={' google.com/intl/en/policies/terms/regional.html'}
          style={{ color: '#206bbb', cursor: 'pointer' }}
        >
          google.com/intl/en/policies/terms/regional.html
        </Link>
        . You find more information about the cookie, you can close any time, in
        our Cookie Policy.
      </TextSmall>

      <TextSmall>
        <TextSmall as='span' fontWeight={700}>
          &quot;Google Maps&quot;
        </TextSmall>
        {`: Each time the "Google Maps" component is called up, Google sets a
        cookie to process user settings and data when the page on which the
        "Google Maps" component is integrated is displayed. As a rule, this
        cookie is not deleted when the browser is closed, but expires after a
        certain period of time, unless you delete it manually beforehand. If you
        do not agree with this processing of your data, you have the option of
        deactivating the "Google Maps" service and thus preventing the transfer
        of data to Google. To do this, you must deactivate the Java Script
        function in your browser. However, we would like to point out that in
        this case you will not be able to use "Google Maps" or only to a limited
        extent. The use of "Google Maps" and the information obtained via
        "Google Maps" is subject to the Google Terms of Use `}
        {
          <Link
            href={'google.com/intl/en/policies/terms/regional.html'}
            style={{ color: '#206bbb', cursor: 'pointer' }}
          >
            google.com/intl/en/policies/terms/regional.html
          </Link>
        }{' '}
        {` and the additional terms and conditions for "Google Maps".`}{' '}
        <Link
          href={'google.com/intl/en_en/help/terms_maps.html'}
          style={{ color: '#206bbb', cursor: 'pointer' }}
        >
          google.com/intl/en_en/help/terms_maps.html
        </Link>
        .
      </TextSmall>

      <TextSmall>
        <TextSmall as='span' fontWeight={700}>
          &quot;Google Fonts&quot;
        </TextSmall>
        {`: We use Google Fonts on our website. These are the "Google fonts" of
        Google Inc. For the European area, the company Google Ireland Limited
        (Gordon House, Barrow Street Dublin 4, Ireland) is responsible for all
        Google services.`}
      </TextSmall>
      <TextSmall>
        You have given your consent in accordance with Art. 6 para. 1 sentence 1
        lit. a GDPR.
      </TextSmall>
      <TextSmall>
        You do not need to log in or enter a password to use Google fonts. No
        cookies are stored in your browser either. The files (CSS, fonts) are
        requested via the Google domains fonts.googleapis.com and
        fonts.gstatic.com. According to Google, requests for CSS and fonts are
        completely separate from all other Google services. If you have a Google
        account, you do not need to worry that your Google account data will be
        transmitted to Google while using Google Fonts.
      </TextSmall>
      <TextSmall>
        With Google Fonts, we can use fonts on our own website, but we do not
        have to upload them to our own server. Google Fonts is an important
        component in keeping the quality of our website high.
      </TextSmall>
      <TextSmall>
        Instead of loading the fonts from the Google server, they are stored and
        integrated locally on your own server or web space. No information is
        transmitted to Google.
      </TextSmall>

      {googleServer.map((data, index) => (
        <TextSmall key={index + 'google'} pl={4}>
          {data}
        </TextSmall>
      ))}

      <DataProccessTable />
    </>
  );
};

export default PersonalDataProcessed;
